import { getServerApi } from '@/gql';
import { Chat } from '@/gql/graph/__generated__/request';
import user from '@/stores/user';
import { useEffect, useState } from 'react';

export interface UseChatsResult {
    chats: Chat[];
    loading: boolean;
    error: Error | null;
    refetch: () => Promise<Chat[]>;
}

export const useChats = (tokenId: number): UseChatsResult => {
    const [chats, setChats] = useState<Chat[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<Error | null>(null);
    const { userId } = user;

    const getChats = async () => {
        if (!tokenId || !userId) {
            setChats([]);
            return [];
        }
        try {
            setLoading(true);
            setError(null);
            const api = getServerApi();
            const response = await api.chats({
                tokenId: tokenId,
                pageNum: 1,
                pageSize: 20,
            });
            if (response?.chats !== undefined) {
                const reversedChats = response.chats.reverse();
                setChats(reversedChats);
                return reversedChats;
            } else {
                setChats([]);
                return [];
            }
        } catch (err) {
            console.error('Failed to fetch chats:', err);
            setError(
                err instanceof Error ? err : new Error('Failed to fetch chats'),
            );
            setChats([]);
            return [];
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getChats();
    }, [tokenId, userId]);

    return {
        chats,
        loading,
        error,
        refetch: getChats,
    };
};
